import request from './request.js'
import requestsNoLoad from './requests.js'

//  MyRequest 页面
export function getMyRequestList(data) {
  return request({
    url: 'request/getData',
    method: 'post',
    params: data  
  });

}
//  Request 页面
export function getRequestList(data) {
  return request({
    url: 'request/getDataForAdmin',
    method: 'post',
    params: data  
  });

}
// allsales 页面
// sale/getPageDepositList
export function getPageDepositList(data) {
  return request({
    url: 'sale/getPageDepositList',
    method: 'post',
    params: data  
  });

}
// /sale/getSaleList
export function getSaleList(data) {
  return request({
    url: 'sale/getSaleList',
    method: 'post',
    params: data  
  });
}
// property/getCancelledData
export function getSaleList2(data) {
  return request({
    url: 'property/getCancelledData',
    method: 'post',
    params: data  
  });
}

// property/getCancelledData
export function getAllSales(data) {
  return request({
    url: 'sale/getAllSales',
    method: 'post',
    params: data  
  });
}
// sale/getSaleRefundDepositList
export function getSaleRefund(data) {
  return request({
    url: 'sale/getSaleRefundDepositList',
    method: 'post',
    params: data  
  });
}
// allReserved查询接口地址：/property/getReservedData
export function getAllReservedProperty(data) {
  return request({
    url: 'property/getReservedData',
    method: 'post',
    params: data  
  });
}
// result/getData
export function getResultList(data) {
  return request({
    url: 'result/getData',
    method: 'post',
    params: data  
  });
}
// /request/getApproving
export function getApprovingCount(data){
  return requestsNoLoad({
    url: 'request/getApprovingCount',
    method: 'post',
    params: data
  });
}
// /request/getAgencyApprove 待审核(渠道)  
export function getAgencyApprove(data){
  return request({
    url: 'request/getAgencyApprove',
    method: 'post',
    params: data
  });
}
// /request/getAgencyApprove 待审核(渠道)  
export function getAgencyApproveForAdmin(data){
  return request({
    url: 'request/getAgencyApproveForAdmin',
    method: 'post',
    params: data
  });
}
//  /request/getAgencyApproved 我的审核(渠道)
export function getAgencyApproved(data){
  return request({
    url: 'request/getAgencyApproved',
    method: 'post',
    params: data
  });
}
// /sale/insertInvoice
export function insertInvoice(data){
  return request({
    url: 'sale/insertInvoice',
    method: 'post',
    params: data
  });
}
// /sale/PdfProperty
export function PdfProperty (data){
  return request({
    url: 'sale/PdfProperty',
    method: 'post',
    params: data
  });
}
// sale/ExcelProperty
export function ExcelProperty (data){
  return request({
    url: 'sale/ExcelProperty',
    method: 'post',
    params: data
  });
}
// sale/getAllInvoices
export function getAllInvoices (data){
  return request({
    url: 'sale/getAllInvoices',
    method: 'post',
    params: data
  });
}

//sale/crossCancel
export function crossCancel (data){
  return request({
    url: 'sale/crossCancel',
    method: 'post',
    params: data
  });
}

//agencySaleVariation/getDataWithSale
export function getSaleVariationDataWithSale (data){
  return request({
    url: 'agencySaleVariation/getDataWithSale',
    method: 'post',
    params: data
  });
}

//agencySaleVariation/update
export function updateSaleVariation (data){
  return request({
    url: 'agencySaleVariation/update',
    method: 'post',
    params: data
  });
}

//agencySaleVariation/insert
export function insertSaleVariation (data){
  return request({
    url: 'agencySaleVariation/insert',
    method: 'post',
    params: data
  });
}

//agencySaleVariation/delete
export function deleteSaleVariation (data){
  return request({
    url: 'agencySaleVariation/delete',
    method: 'post',
    params: data
  });
}

// sale/changeAgency
export function changeAgency (data){
  return request({
    url: 'sale/changeAgency',
    method: 'post',
    params: data
  });
}

// sale/updateSnoozeTime
export function updateSnoozeTime (data){
  return request({
    url: 'sale/updateSnoozeTime',
    method: 'post',
    params: data
  });
}

// sale/removeAutoCancel
export function removeAutoCancel (data){
  return request({
    url: 'sale/removeAutoCancel',
    method: 'post',
    params: data
  });
}
// sale/archive
export function archive (data){
  return request({
    url: 'sale/archive',
    method: 'post',
    params: data
  });
}
// sale/getArchiveData
export function getArchiveData (data){
  return request({
    url: 'sale/getArchiveData',
    method: 'post',
    params: data
  });
}
// sale/deleteArchive
export function deleteArchive (data){
  return request({
    url: 'sale/deleteArchive',
    method: 'post',
    params: data
  });
}
// request/notifyForAdmin
export function notifyRequestForAdmin (data){
  return request({
    url: 'request/notifyForAdmin',
    method: 'post',
    params: data
  });
}
// request/notifyAgencyApproveForAdmin
export function notifyAgencyApproveForAdmin (data){
  return request({
    url: 'request/notifyAgencyApproveForAdmin',
    method: 'post',
    params: data
  });
}

export function exportDataOfSales(data) {
  return request({
    url: 'dataExport/exportDataOfSales',
    method: 'post',
    params: data  
  });
}

export function getPropertyReport(data){
  return request({
    url: "property/getPropertyReport",
    method: "post",
    params: data,
  });
}

export function getHouseLandPropertyReport(data) {
  return request({
    url: "property/getHouseLandPropertyReport",
    method: "post",
    params: data,
  });
}

export function getCommercialPropertyReport(data) {
  return request({
    url: "property/getCommercialPropertyReport",
    method: "post",
    params: data,
  });
}

export function getPurchaserSaleData(data) {
  return request({
    url: "client/getClientCountByClientSource",
    method: "post",
    params: data,
  });
}

export function getPurchaserMapData(data) {
  return request({
    url: "client/getMapDataByClientSource",
    method: "post",
    params: data,
  });
}

export function getSaleCountByClientSource(data) {
  return request({
    url: "sale/getSaleCountByClientSource",
    method: "post",
    params: data,
  });
}

export function getEnquirySaleData(data) {
  return request({
    url: "client/getClientCountByClientSource2",
    method: "post",
    params: data,
  });
}

export function getEnquiryMapData(data) {
  return request({
    url: "client/getMapDataByClientSource2",
    method: "post",
    params: data,
  });
}

export function getLeadAndEnquiriesData(data) {
  return request({
    url: "agentClientContact/getClientEnquireLog",
    method: "post",
    params: data,
  });
}

export function getProjectSalesNum(data) {
  return request({
    url: "sale/getProjectSalesNum",
    method: "post",
    params: data,
  });
}

export function getPropertyReportByLevel(data) {
  return request({
    url: "property/getPropertyReportByLevel",
    method: "post",
    params: data,
  });
}

export function getPropertyReportByStageNo(data) {
  return request({
    url: "property/getPropertyReportByStageNo",
    method: "post",
    params: data,
  });
}

export function getHouseLandPropertyReportByStageNo(data) {
  return request({
    url: "property/getHouseLandPropertyReportByStageNo",
    method: "post",
    params: data,
  });
}

export function getCommercialReportByBuilding(data) {
  return request({
    url: "property/getPropertyReportByBuilding",
    method: "post",
    params: data,
  });
}

export function getAssociatedProjectByAgencyId(data) {
  return request({
    url: "project/getOptionDataByAgencyID",
    method: "post",
    params: data,
  });
}

export function getAvailableProperty(data) {
  return request({
    url: "property/getAvailableData",
    method: "post",
    params: data,
  });
}

export function insertSaleByExcel(data) {
  return request({
    url: "property/insertSaleByExcel",
    method: "post",
    params: data,
  });
}

// sale/sendCreationHomeSalesAdviceForSign
export function sendCreationHomeSalesAdviceForSign(data) { 
  return request({
      url: 'sale/sendCreationHomeSalesAdviceForSign',
      method: 'post',
      params: data    
  });
}

export function getSalePurchaserData(data) {
  return request({
    url: "sale/getSalePurchaserData",
    method: "post",
    params: data,
  });
}

export function getBillbergiaSaleAdvice(data) {
  return request({
    url: "request/getBillbergiaSaleAdvice",
    method: "post",
    params: data,
  });
}


export function sendBillbergiaSaleDocForSign(data) {
  return request({
    url: "sale/sendBillbergiaSaleDocForSign",
    method: "post",
    params: data,
  });
}

export function downloadBillBergiaSalePdf(data) {
  return request({
    url: "request/downloadBillBergiaSalePdf",
    method: "post",
    params: data,
  });
}

export function downloadBillBergiaSaleVariationRequestPdf(data) {
  return request({
    url: "request/downloadBillBergiaSaleVariationRequestPdf",
    method: "post",
    params: data,
  });
}

export function getAccountingDepositReport(data) {
  return request({
    url: "sale/getAccountingDepositReport",
    method: "post",
    params: data,
  });
}

export function ExcelAccountingDepositReport(data) {
  return request({
    url: "sale/ExcelAccountingDepositReport",
    method: "post",
    params: data,
  });
}

export function getPromotionsReport(data) {
  return request({
    url: "sale/getPromotionsReport",
    method: "post",
    params: data,
  });
}

export function ExcelPromotionsReport(data) {
  return request({
    url: "sale/ExcelPromotionsReport",
    method: "post",
    params: data,
  });
}

export function getSalesVariationReport(data) {
  return request({
    url: "sale/getSalesVariationReport",
    method: "post",
    params: data,
  });
}

export function ExcelSalesVariationReport(data) {
  return request({
    url: "sale/ExcelSalesVariationReport",
    method: "post",
    params: data,
  });
}

/** Billbergia — update sale（saleid + uom / holdingdeposit 等） */
export function updateSaleBillbergia(data) {
  return request({
    url: "sale/updateSaleBillbergia",
    method: "post",
    params: data,
  });
}

export function getAgencyPerformanceReport(data) {
  return request({
    url: "sale/getAgencyPerformanceReport",
    method: "post",
    params: data,
  });
}

export function ExcelAgencyPerformanceReport(data) {
  return request({
    url: "sale/ExcelAgencyPerformanceReport",
    method: "post",
    params: data,
  });
}

export function getSaleableAreaReport(data) {
  return request({
    url: "sale/getSaleableAreaReport",
    method: "post",
    params: data,
  });
}

export function ExcelSaleableAreaReport(data) {
  return request({
    url: "sale/ExcelSaleableAreaReport",
    method: "post",
    params: data,
  });
}

export function getPurchaserReport(data) {
  return request({
    url: "sale/getPurchaserReport",
    method: "post",
    params: data,
  });
}

export function ExcelPurchaserReport(data) {
  return request({
    url: "sale/ExcelPurchaserReport",
    method: "post",
    params: data,
  });
}

export function getListingConveyancerStatusReport(data) {
  return request({
    url: "sale/getListingConveyancerStatusReport",
    method: "post",
    params: data,
  });
}

export function ExcelListingConveyancerStatusReport(data) {
  return request({
    url: "sale/ExcelListingConveyancerStatusReport",
    method: "post",
    params: data,
  });
}

export function getPropertyStatusReport(data) {
  return request({
    url: "sale/getPropertyStatusReport",
    method: "post",
    params: data,
  });
}

export function ExcelPropertyStatusReport(data) {
  return request({
    url: "sale/ExcelPropertyStatusReport",
    method: "post",
    params: data,
  });
}

/** Billbergia — Sales Summary（projectid，对应 sale/getSalesSummaryReport?projectid=） */
export function getSalesSummaryReport(data) {
  return request({
    url: "sale/getSalesSummaryReport",
    method: "post",
    params: data,
  });
}

/** Billbergia All Sales Report — summary by project */
export function getSalesGroupByProject(data) {
  return request({
    url: "sale/getSalesGroupByProject",
    method: "post",
    params: data,
  });
}

/** Billbergia All Sales Report — summary by agent */
export function getSalesGroupByAgent(data) {
  return request({
    url: "sale/getSalesGroupByAgent",
    method: "post",
    params: data,
  });
}

/** Billbergia All Sales Report — summary by agency type */
export function getSalesGroupByAgencyType(data) {
  return request({
    url: "sale/getSalesGroupByAgencyType",
    method: "post",
    params: data,
  });
}

/** Billbergia All Sales Report — sales list */
export function getAllBillbergiaSales(data) {
  return request({
    url: "sale/getAllBillbergiaSales",
    method: "post",
    params: data,
  });
}

/** Billbergia All Sales Report — export Excel */
export function ExcelBillbergiaSalesReport(data) {
  return request({
    url: "sale/ExcelBillbergiaSalesReport",
    method: "post",
    params: data,
  });
}

// Billbergia - Colour Scheme Variation
export function insertSalesChemeVariation(data) {
  return request({
    url: "salesChemeVariation/insert",
    method: "post",
    params: data,
  });
}

export function getSalesChemeVariationData(data) {
  return request({
    url: "salesChemeVariation/getData",
    method: "post",
    params: data,
  });
}

export function deleteSalesChemeVariation(data) {
  return request({
    url: "salesChemeVariation/delete",
    method: "post",
    params: data,
  });
}

export function ExcelSalesChemeVariationReport(data) {
  return request({
    url: "salesChemeVariation/ExcelSalesChemeVariationReport",
    method: "post",
    params: data,
  });
}

// Billbergia - Sale Referrer
export function insertSaleReferrer(data) {
  return request({
    url: "saleReferrer/insert",
    method: "post",
    params: data,
  });
}

export function getSaleReferrerData(data) {
  return request({
    url: "saleReferrer/getData",
    method: "post",
    params: data,
  });
}

export function deleteSaleReferrer(data) {
  return request({
    url: "saleReferrer/delete",
    method: "post",
    params: data,
  });
}

export function ExcelSaleReferrerReport(data) {
  return request({
    url: "saleReferrer/ExcelSaleReferrerReport",
    method: "post",
    params: data,
  });
}

// Creation Homes - Weekly Report
export function getWeeklyReport(data) {
  return request({
    url: "sale/getWeeklyReport",
    method: "post",
    params: data,
  });
}

export function ExcelWeeklyReport(data) {
  return request({
    url: "sale/ExcelWeeklyReport",
    method: "post",
    params: data,
  });
}

// Creation Homes - Monthly Report
export function getMonthlyReport(data) {
  return request({
    url: "sale/getMonthlyReport",
    method: "post",
    params: data,
  });
}

export function ExcelMonthlyReport(data) {
  return request({
    url: "sale/ExcelMonthlyReport",
    method: "post",
    params: data,
  });
}

export function getChannelManagerCount(data) {
  return request({
    url: "sale/getChannelManagerCount",
    method: "post",
    params: data,
  });
}

// Creation Homes - Project Report
export function getProjectReport(data) {
  return request({
    url: "sale/getProjectReport",
    method: "post",
    params: data,
  });
}

export function ExcelProjectReport(data) {
  return request({
    url: "sale/ExcelProjectReport",
    method: "post",
    params: data,
  });
}

// Creation Homes - update commissions
export function updateSaleCreationHome(data) {
  return request({
    url: "sale/updateSaleCreationHome",
    method: "post",
    params: data,
  });
}

// Koham - Sales Report
export function getKohamSalesReport(data) {
  return request({
    url: "sale/getKohamSalesReport",
    method: "post",
    params: data,
  });
}

export function ExcelKohamSalesReport(data) {
  return request({
    url: "sale/ExcelKohamSalesReport",
    method: "post",
    params: data,
  });
}















// WEBPACK FOOTER //
// ./src/api/saleApi.js